import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  send({ params: { eventName, path, location } }) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    fetch('/note/events', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken },
      body: JSON.stringify({ event_name: eventName, location, path })
    })
  }
}
